import { useMutation, useQueryClient } from '@common-fe/common-fe';
import _ from 'lodash';

import { api } from '@/api';
import { API_URL, ITaxFormMailingCreateDto, ITaxFormMailingCreateDtoFormTypeEnum } from '@/dtos';

import { TAX_FORMS_LIST_QUERY_KEY } from '../../queries/useTaxFormsList.query';
import { ITaxModalPayload } from '../../TaxForms.types';

const useTaxFormSendMEssageQueueQuery = () => {
  const queryClient = useQueryClient();
  const { isLoading, mutateAsync } = useMutation(
    (payload: ITaxModalPayload) =>
      api.post<unknown, unknown, ITaxFormMailingCreateDto>(API_URL.TAX_FORMS_MAILING_HISTORY, {
        tax_form_id: _.toNumber(payload.id),
        form_type: payload.type as unknown as ITaxFormMailingCreateDtoFormTypeEnum,
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [TAX_FORMS_LIST_QUERY_KEY],
        });
      },
    }
  );
  return {
    isLoading,
    submit: mutateAsync,
  };
};
export default useTaxFormSendMEssageQueueQuery;
